// Core
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Styles
import "./style.scss";

// Svg
import calendarIcon from "../../Assets/Images/calendarIcon.svg";

const CommonDatePicker = ({
  onChange,
  placeholder,
  value,
  maxDate,
  minDate,
  dateFormat = "dd/MM/yyyy",
  isClearable = false,
  id = "datepicker",
  disabled,
  customStyle,
}) => {
  const handleIconClick = () => {
    const element = document.getElementById(id);
    if (element) {
      element.focus();
    }
  };
  let selectedDate = value ? new Date(value) : null;

  return (
    <div className="datePicker" style={customStyle} onClick={handleIconClick}>
      <DatePicker
        id={id}
        placeholderText={placeholder}
        onChange={onChange}
        value={value}
        isClearable={isClearable}
        selected={selectedDate}
        maxDate={maxDate}
        minDate={minDate}
        dateFormat={dateFormat}
        autoComplete="off"
        disabled={disabled}
        popperClassName="custom-datepicker-popper"
      />
      <span className="calendarIcon" >
        <img src={calendarIcon} alt="calendar" />
      </span>
    </div>
  );
};

export default CommonDatePicker;
